import { FormControlLabel as i, formControlLabelClasses as o, Radio as n, buttonBaseClasses as s, radioClasses as a } from "@mui/material";
import { styled as t, css as l } from "./styled2.mjs";
const c = t(i)`
	align-items: ${({ $radioPlacement: r }) => r === "center" ? "center" : "flex-start"};
	text-align: start;
	${({ theme: r, $hasError: e }) => {
  if (e)
    return l`
				.${o.label} {
					color: ${r.palette.error.main};
					&.${o.disabled} {
						color: ${r.palette.error.main30};
					}
				}
			`;
}};
`, $ = t(n)`
	${({ theme: r, $radioPlacement: e }) => {
  if (e === "top")
    return l`
				margin-top: -${r.spacing(1.5)};
			`;
}};

	color: ${({ theme: r, $hasError: e }) => e ? r.palette.error.main : r.palette.text.body};

	&.${s.root} {
		border-radius: 50%;

		&:hover {
			background-color: ${({ theme: r, $hasError: e }) => e ? r.palette.error.main08 : r.palette.action.hover};

			&.${a.checked} {
				background-color: ${({ theme: r, $hasError: e }) => e ? r.palette.error.main08 : r.palette.primary.main08};
			}
		}
	}

	&.${a.disabled} {
		color: ${({ theme: r, $hasError: e }) => e ? r.palette.error.main30 : r.palette.text.disabled};
	}

	&.${a.checked} {
		color: ${({ theme: r, $hasError: e }) => e ? r.palette.error.main : r.palette.primary.main};

		&.${a.disabled} {
			color: ${({ theme: r, $hasError: e }) => e ? r.palette.error.main30 : r.palette.primary.main30};
		}
	}
`;
export {
  $ as StyledRadio,
  c as StyledRadioLabel
};
//# sourceMappingURL=styles48.mjs.map
